export const textTruncate = (text, len = 25) => {
  return text?.length > len ? `${text.slice(0, len)}...` : text;
};
